import { ApiDimension } from "@incendium/api";
import { enumToArray } from "Helpers/enumToText";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const useDimensionQueryParams = () => {
  const location = useLocation();

  return useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    const validParams: Record<string, string> = {};

    queryParams.forEach((value, key) => {
      if (enumToArray(ApiDimension).includes(key as ApiDimension)) {
        validParams[key] = value;
      }
    });

    return validParams;
  }, [location.search]);
};

export default useDimensionQueryParams;
